module.exports = __webpack_public_path__ + "img/card.f5aba8fd.png";